import ngMaterial from 'angular-material';
import uiRouter from 'angular-ui-router';

// import modules this module depends on
import angularTranslate from 'angular-translate';
import * as acceptExistingUser from './accept-existing-user.controller';

// import this modules components

import './accept-existing-user.scss';

// define the module in one place and export the module name
export default angular.module('register.components.acceptexistinguser', [
  uiRouter,
  ngMaterial,
  angularTranslate,
  'rhino.components.locale',
  'rhino.components.invitation',
  'rhino.components.session',
  'rhino.core',
  'angulartics'
])
  .controller(acceptExistingUser.name, acceptExistingUser.default)
  .name;



// WEBPACK FOOTER //
// ./components/accept/user/accept-existing-user.module.js